import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
})

export const app_sso = !process.env.REACT_APP_SSO_PROJECT_ID ? app :
  firebase.initializeApp({
    apiKey: process.env.REACT_APP_SSO_API_KEY,
    authDomain: process.env.REACT_APP_SSO_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_SSO_PROJECT_ID,
    appId: process.env.REACT_APP_SSO_APP_ID
  }, 'sso')

export default app
